import {PowderCoat} from './powder-coat.js';
// Frost on a cold mochi, kept per vertex of the rest mesh like powder (0..1).
// A finger resting on it melts a round patch with its warmth, rubbing melts
// faster, cupped hands melt it all over, and left alone it grows back from
// the cold, slowly at first and faster as the crystals spread.
const smooth=(a,b,x)=>{const t=Math.max(0,Math.min(1,(x-a)/(b-a)));return t*t*(3-2*t);};
const hash=i=>{const s=Math.sin(i*12.9898+78.233)*43758.5453;return s-Math.floor(s);};
export class FrostCoat extends PowderCoat{
  // Frosted all over except one clear swipe low on the front right, so the
  // first look already shows the bare pink skin under the frost.
  prime(){
    const p=this.rest,c=this.center,R=this.radius;
    for(let i=0;i<this.powder.length;i++){
      const u=(p[i*3]-c[0])/R,v=(p[i*3+1]-c[1])/R,front=smooth(.25,.45,(p[i*3+2]-c[2])/R);
      const line=-.15+.45*(u-.3),swipe=Math.exp(-(((v-line)/.2)**2))*smooth(-.05,.08,u)*(1-smooth(.72,.86,u))*front;
      this.powder[i]=1-.97*swipe;
    }
    this.primed=this.powder.slice();this.changed=true;
  }
  get coverage(){let sum=0;for(const v of this.powder)sum+=v;return this.powder.length?sum/this.powder.length:0;}
  warm(point,dt){
    this.near(point,this.radius*.42,(i,w)=>{const next=Math.max(0,this.powder[i]-dt*1.4*w);if(next!==this.powder[i]){this.powder[i]=next;this.changed=true;}});
  }
  warmAll(dt){
    for(let i=0;i<this.powder.length;i++)this.powder[i]=Math.max(0,this.powder[i]-dt*.6*(.7+.6*hash(i)));
    this.changed=true;
  }
  regrow(dt){
    let changed=false;
    for(let i=0;i<this.powder.length;i++){
      const f=this.powder[i];if(f>=1)continue;
      this.powder[i]=Math.min(1,f+dt*(.12+.1*hash(i))*(.35+f));changed=true;
    }
    if(changed)this.changed=true;
  }
}
